<template>
  <div class="footer">
    <div class="footer-quote no-print">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2 text-center">
            <p>OpenCabana partners with the world's top resorts to offer and provide VIP beach and poolside cabana services.</p>
          </div><!-- end .col-lg-12 -->
        </div><!-- end .row -->
      </div><!-- end .container -->
    </div>
    <div class="footer-links no-print">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <ul class="footer-links">
              <li class="active"><a href="#/pages/contact">Contact</a></li>
              <li class="active"><a href="#/hotel-partners">Hotel Partners</a></li>
              <li class="active"><a href="#/pages/terms">Terms</a></li>
              <li class="active"><a href="#/pages/privacy">Privacy</a></li>
            </ul>
          </div><!-- end .col-md-6 -->
          <div class="col-lg-6 text-right">
            <ul class="social-icons">
              <li><a href="https://www.facebook.com/opencabana/" target="_blank"><i class="fa fa-facebook-official" aria-hidden="true"></i></a></li>
              <li><a href="https://www.instagram.com/opencabana/" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
              <li><a href="https://www.twitter.com/opencabana/" target="_blank"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
            </ul>
          </div><!-- end .col-md-6 -->
        </div><!-- end .row -->
        <div class="row">
          <div class="col-lg-12 text-center">
            <div class="copyright">&copy; OpenCabana, {{ date }}.</div>
          </div><!-- end .col-md-12 -->
        </div><!-- end .row -->
      </div><!-- end .container -->
    </div><!-- end .footer-links -->
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'AppFooter',
  data() {
    return {
      date: moment(new Date()).format('YYYY')
    }
  }
}
</script>


// WEBPACK FOOTER //
// AppFooter.vue?1502bca2